import React, { useContext } from 'react';
import Stats from '../../common/Stats';
import { CurrentApplicationContext } from '../../ApplicationOverview';
import { getTranslatedString } from 'helpers/i18n';

const ApplicationReviewStats = () => {
  const currentApplication = useContext(CurrentApplicationContext);

  return (
    <Stats
      items={[
        {
          title: getTranslatedString(
            'landlordPortal.applicationManagement.applicationOverview.review.statistics.rentToIncome'
          ),
          value: currentApplication.applicants_rent_to_income
            ? `${(currentApplication.applicants_rent_to_income * 100).toFixed(0)}%`
            : null,
        },
        {
          title: getTranslatedString(
            'landlordPortal.applicationManagement.applicationOverview.review.statistics.flags'
          ),
          value: null,
        },
        {
          title: getTranslatedString(
            'landlordPortal.applicationManagement.applicationOverview.review.statistics.overrides'
          ),
          value: null,
        },
      ]}
      valueStyle={{ display: 'block', textAlign: 'center' }}
    />
  );
};

export default ApplicationReviewStats;
